import type { InlineInputProps, SelectOption } from '@ztechapps/webui.input'
import React from 'react'
import { TemplateSelectInlineInput } from '@ztechapps/webui.data-tools'
import { orderItemRemarksTemplateCategory } from '@ztechapps/order.common'

type OrderItemRemarkInputProps = {
  orderId: string
}

export const OrderItemRemarkSelectInlineInput = ({
  inputProps,
  displayContent,
  updateParams,
  emptyContent,
  ...rest
}: InlineInputProps<OrderItemRemarkInputProps>) => {
  const { orderId, ...restInputProps } = inputProps

  emptyContent =
    emptyContent ??
    ((onClick, { canEdit }) => {
      return canEdit && <div>[Add remarks]</div>
    })
  updateParams =
    updateParams ??
    (({ _id, updatedValue }) => {
      return {
        input: {
          remarks: updatedValue?.value ?? updatedValue,
        },
        filter: { 'items._id': _id, _id: orderId },
      }
    })
  displayContent =
    displayContent ??
    ((remarks: SelectOption) => {
      return <div>{remarks?.value ? `** ${remarks?.value}` : ((remarks as unknown as string) ?? '')}</div>
    })

  return (
    <TemplateSelectInlineInput
      templateCategory={orderItemRemarksTemplateCategory}
      emptyContent={emptyContent}
      updateParams={updateParams}
      displayContent={displayContent}
      inputProps={{ ...restInputProps, isClearable: true, placeholder: 'Select a remark.' }}
      {...rest}
    />
  )
}
